// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"ed2dc5bd","73":"f50c1fad","86":"8a0723e7","213":"38cbda13","239":"b19b3090","413":"f7d251eb","454":"d1b95dff","455":"601ddeb5","487":"c2718e0d","503":"a2b28eeb","642":"3727bdb7","690":"1c269ded","742":"8f6655fb","770":"83a196d9","794":"0640441a","974":"ecb62aa5"}[chunkId] + ".chunk.js";
};